/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class DealerApi {
    static getInstance() {
        if (!this.instance) this.instance = new DealerApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取经销商列表
    async getDealerList (param, page_num, page_size){
        let url = `/api/dealer/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取临时token
    async getShortToken(){
        let url = `/api/user/token/short`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取国家下拉配置
    async getCountry(param){
        // let url = `/api/system/dictionary/country`
        let url = `/api/system/country/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存erp code
    async saveErpCode(param,id){
        let url = `/api/dealer/update/code/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 经销商评级
    async setLevel(param,id){
        let url = `/api/dealer/update/level/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 经销商预订单列表-头
    async getDealerOrderHead(param,page_num,page_size){
        let url = `/api/business/order/head/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 经销商预订单列表-行
     async getDealerOrderLine(param){
        let url = `/api/business/order/line/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 经销商业务订单生成订单-保存
    async savebusinessOrder(param){
        let url = `/api/order/head/business/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 关闭业务订单
    async closeOrder(id){
        let url = `/api/business/order/head/${id}/close`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导出dealer
    async exportDealer(param){
        let url = `/api/dealer/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑经销商信息
    async editDealer(param){
        let url = `/api/dealer/update`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 更新dealer其他信息
    async editDealerOther(param,id){
        let url = `/api/dealer/update/other/${id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取注册用户（销售）信息
    async getUser(){
        let url = `/api/user`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取区域销售经理列表
    async getAreaSaleManagerList (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取预测列表
    async getYearEstimateList (param){
        let url = `/api/dealer/year/estimate/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 保存B2B Shop订单
     async saveB2BOrder (param){
        let url = `/api/order/head/dealer/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取B2B Shop订单头列表
    async getB2BOrderList (param, page_num, page_size){
        // let url = `/api/dealer/order/head/list?page_num=${page_num}&page_size=${page_size}`
        let url = `/api/dealer/order/head/view/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取B2B Shop订单行列表
    async getB2BOrderLine (param){
        let url = `/api/dealer/order/line/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消订单
    async cancelOrder (param, id){
        let url = `/api/dealer/order/head/${id}/close`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取opo列表
    async getOpoList (param,num,size){
        let url = `/api/invoice/view/opo/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 导出opo
    async exportOpo(param){
        let url = `/api/invoice/view/export/opo`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取价目表
    async getPriceList (param,num,size){
        let url = `/api/system/source/price/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 导出价目表
    async exportPrice (param){
        let url = `/api/system/source/price/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    }
   

}

export {
    DealerApi
}